module.exports = __webpack_public_path__ + "img/image003.238d4e7d.jpg";